// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8a53c525","239":"67ea8252","453":"97cb4b00","455":"dce72f66"}[chunkId] + ".chunk.js";
};